import clsx from 'clsx';

import {
  MantineTheme,
  PartialVarsResolver,
  RadioFactory,
  RadioProps,
  RadioStylesNames,
  rem
} from '@mantine/core';

import classes from './Radio.module.css';

export const DefaultRadioProps: Partial<RadioProps> = {
  size: 'sm',
  color: 'primary'
};

export const varsResolver: PartialVarsResolver<RadioFactory> = (
  _theme: MantineTheme,
  props: RadioProps
) => {
  if (props.size === 'xs') {
    return {
      root: {
        '--radio-size': rem(10),
        '--radio-icon-size': rem(4)
      }
    };
  } else if (props.size === 'sm') {
    return {
      root: {
        '--radio-size': rem(12),
        '--radio-icon-size': rem(6)
      }
    };
  } else if (props.size === 'md') {
    return {
      root: {
        '--radio-size': rem(14),
        '--radio-icon-size': rem(6)
      }
    };
  } else if (props.size === 'lg') {
    return {
      root: {
        '--radio-size': rem(16),
        '--radio-icon-size': rem(8)
      }
    };
  } else if (props.size === 'xl') {
    return {
      root: {
        '--radio-size': rem(18),
        '--radio-icon-size': rem(8)
      }
    };
  }

  return {
    root: {
      '--radio-size': rem(14),
      '--radio-icon-size': rem(6)
    }
  };
};

export const RadioOverrideClassNames: (
  theme: MantineTheme | undefined,
  props: RadioProps
) => Partial<Record<RadioStylesNames, string>> = (_theme, props) => {
  return {
    root: classes.root,
    radio: clsx(classes.radio, {
      [classes.primaryRadio]: props.color === 'primary',
      [classes.successRadio]: props.color === 'success',
      [classes.dangerRadio]: props.color === 'danger'
    }),
    label: classes.label,
    body: classes.body,
    error: classes.error
  };
};

export const RadioGroupOverrideClassNames: () => Partial<
  Record<RadioStylesNames, string>
> = () => {
  return {
    error: classes.errorRadioGroup
  };
};
